<template>
  <div class="video-overlay">
    <div class="bg" v-on:click.prevent="closeVideo" aria-hidden="true"></div>
    <div class="video-container" id="videoContainer">
      <strong>
        <button v-on:click.prevent="closeVideo" 
          ref="closeButton"
          aria-label="Video schließen"
        >
          <span class="visually-hidden">Video schließen</span>
          <i class="icon-close" aria-hidden="true"></i>
        </button>
      </strong>
      <youtube
        :video-id="youtubeId"
        ref="youtube"
        :player-vars="{ autoplay: 1 }"
        width="1200"
        height="675"
        :resize="true"
        :fit-parent="true"
        :nocookie="true"
        aria-label="Feuerwerk in Aktion Video"
      ></youtube>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    youtubeId: {
      type: String,
      required: true
    }
  },
  methods: {
    closeVideo() {
      this.$emit("closeVideo");
    }
  },
  mounted() {
    window.setTimeout(() => {
      this.$refs.closeButton && this.$refs.closeButton.focus();
    }, 100);
    window.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') {
        this.closeVideo();
      }
    });
  }
};
</script>

<style lang="scss">
@import "../scss/settings";
.video-overlay {
  position: fixed;
  left: 0;
  top: 0;
  z-index: 800;
  width: 100%;
  height: 100%;
  .bg {
    position: absolute;
    left: 0;
    top: 0;
    z-index: 100;
    width: 100%;
    height: 100%;
    background: rgba(35, 35, 35, 0.6);
  }
  
  .video-container {
    position: absolute;
    left: 50%;
    top: 50%;
    z-index: 100;
    width: 100%;
    max-width: 1200px;
    max-height: 675px;
    transform: translate(-50%, -50%);
    @media screen and (max-height: 420px) {
      max-width: 60%;
      transform: translate(-50%, -50%);
    }
    strong {
      @include fontBold;
      font-size: px-to-rem(36);
      display: block;
      margin-bottom: 10px;
      width: 100%;
      span {
        @include mobile {
          display: none;
        }
      }

      button {
        display: block;
        float: right;
        width: 40px;
        height: 40px;
        border-radius: 20px;
        background: #ffffff;
        padding: 0;
        text-align: center;
        padding-right: 6px;
        margin-bottom: 10px;
        @include mobile {
          margin-right: 10px;
        }
        i {
          color: #000000;
          font-size: 0.8rem;
        }
      }
    }
    iframe {
      background: #000000;
    }
  }
}
</style>
